const checkLoginRequired = (accessToken: any, refreshExpiredAtString: any) => {
  const isAccessTokenPresent = accessToken === "undefined" || !accessToken;

  let isRefreshExpired = true;

  if (refreshExpiredAtString) {
    const expiryDate = new Date(refreshExpiredAtString as string);
    isRefreshExpired = expiryDate < new Date();
  }

  const isLoginRequired = isAccessTokenPresent || isRefreshExpired;

  return isLoginRequired;
};

export { checkLoginRequired };
